import * as types from 'src/store/mutation-types'
import { LocalStorage, Platform } from 'quasar'

// initial state
// shape: [{ id, quantity }]
const state = {
  invoiceDisplayType: Platform.is.mobile ? 'grid' : 'list',
  autoGenerateInvoiceNumber: true,
  autoGenerateQuoteNumber: true,
  autoGenerateCustomerNumber: true,
  lastSalesTax: null,
  showDashboardRevenueAverage: false,
  showDashboardExpensesAverage: false
}

// getters
const getters = {
  invoiceDisplayType: state => state.invoiceDisplayType,
  autoGenerateInvoiceNumber: state => state.autoGenerateInvoiceNumber,
  autoGenerateQuoteNumber: state => state.autoGenerateQuoteNumber,
  autoGenerateCustomerNumber: state => state.autoGenerateCustomerNumber,
  lastSalesTax: state => state.lastSalesTax,
  showDashboardRevenueAverage: state => state.showDashboardRevenueAverage,
  showDashboardExpensesAverage: state => state.showDashboardExpensesAverage
}

const actions = {
  loadLocalSettings ({ commit }) {
    if (!LocalStorage.has('localSettings')) {
      return
    }

    const settings = LocalStorage.get.item('localSettings')
    commit(types.SET_INVOICE_DISPLAY_TYPE, settings.invoiceDisplayType)
    commit(types.SET_AUTO_GENERATE_INVOICE_NUMBER, settings.autoGenerateInvoiceNumber)
    commit(types.SET_AUTO_GENERATE_QUOTE_NUMBER, settings.autoGenerateQuoteNumber)
    commit(types.SET_AUTO_GENERATE_CUSTOMER_NUMBER, settings.autoGenerateCustomerNumber)
    commit(types.SET_LAST_SALES_TAX, settings.lastSalesTax)
    commit(types.SET_SHOW_DASHBOARD_REVENUE_AVERAGE, settings.showDashboardRevenueAverage)
    commit(types.SET_SHOW_DASHBOARD_EXPENSES_AVERAGE, settings.showDashboardExpensesAverage)
  },

  setInvoiceDisplayType ({ commit }, type) {
    commit(types.SET_INVOICE_DISPLAY_TYPE, type)
    commit(types.PERSIST_LOCAL_SETTINGS)
  },

  setAutoGenerateInvoiceNumber ({ commit }, value) {
    commit(types.SET_AUTO_GENERATE_INVOICE_NUMBER, value)
    commit(types.PERSIST_LOCAL_SETTINGS)
  },

  setAutoGenerateQuoteNumber ({ commit }, value) {
    commit(types.SET_AUTO_GENERATE_QUOTE_NUMBER, value)
    commit(types.PERSIST_LOCAL_SETTINGS)
  },

  setAutoGenerateCustomerNumber ({ commit }, value) {
    commit(types.SET_AUTO_GENERATE_CUSTOMER_NUMBER, value)
    commit(types.PERSIST_LOCAL_SETTINGS)
  },

  setLastSalesTax ({ commit }, value) {
    commit(types.SET_LAST_SALES_TAX, value)
    commit(types.PERSIST_LOCAL_SETTINGS)
  },

  setShowDashboardRevenueAverage ({ commit }, value) {
    commit(types.SET_SHOW_DASHBOARD_REVENUE_AVERAGE, value)
    commit(types.PERSIST_LOCAL_SETTINGS)
  },

  setShowDashboardExpensesAverage ({ commit }, value) {
    commit(types.SET_SHOW_DASHBOARD_EXPENSES_AVERAGE, value)
    commit(types.PERSIST_LOCAL_SETTINGS)
  }
}

// mutations
const mutations = {
  [types.SET_INVOICE_DISPLAY_TYPE] (state, setting) {
    state.invoiceDisplayType = setting || state.invoiceDisplayType
  },

  [types.PERSIST_LOCAL_SETTINGS] (state) {
    LocalStorage.set('localSettings', {
      invoiceDisplayType: state.invoiceDisplayType,
      autoGenerateInvoiceNumber: state.autoGenerateInvoiceNumber,
      autoGenerateQuoteNumber: state.autoGenerateQuoteNumber,
      autoGenerateCustomerNumber: state.autoGenerateCustomerNumber,
      lastSalesTax: state.lastSalesTax,
      showDashboardRevenueAverage: state.showDashboardRevenueAverage,
      showDashboardExpensesAverage: state.showDashboardExpensesAverage
    })
  },

  [types.SET_AUTO_GENERATE_INVOICE_NUMBER] (state, setting) {
    state.autoGenerateInvoiceNumber = setting !== undefined ? setting : state.autoGenerateInvoiceNumber
  },

  [types.SET_AUTO_GENERATE_QUOTE_NUMBER] (state, setting) {
    state.autoGenerateQuoteNumber = setting !== undefined ? setting : state.autoGenerateQuoteNumber
  },

  [types.SET_AUTO_GENERATE_CUSTOMER_NUMBER] (state, setting) {
    state.autoGenerateCustomerNumber = setting !== undefined ? setting : state.autoGenerateCustomerNumber
  },

  [types.SET_LAST_SALES_TAX] (state, setting) {
    state.lastSalesTax =
      setting !== undefined && setting !== null
        ? setting
        : state.lastSalesTax
  },

  [types.SET_SHOW_DASHBOARD_REVENUE_AVERAGE] (state, setting) {
    state.showDashboardRevenueAverage = setting !== undefined ? setting : state.showDashboardRevenueAverage
  },

  [types.SET_SHOW_DASHBOARD_EXPENSES_AVERAGE] (state, setting) {
    state.showDashboardExpensesAverage = setting !== undefined ? setting : state.showDashboardExpensesAverage
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
